import Vue from 'vue'
import Router from 'vue-router'
import Pc from '@/pages/Pc'

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [{
        path: '/pc',
        name: 'Pc',
        component: Pc
    }, {
        path: '/pc/',
        name: 'Pc2',
        component: Pc
    }, {
        path: '/pc/index.html',
        name: 'Pc3',
        component: Pc
    }]
})



// WEBPACK FOOTER //
// ./src/router/index.js